export const pages = [
  'peanut butter',
  'dog food',
  'raw meat',
  'cucumber',
  'lucky charms',
  'chocolate',
  'turkey',
  'cheese',
  'avocado',
  'milk',
  'rice cakes',
  'almonds',
  'bologna',
  'apples',
  'pumpkin',
  'sea salt',
  'marshmallow',
  'rose petals',
  'diet soda',
  'cashews',
  'pudding',
  'hot pockets',
  'pancake batter',
  'bubble gum',
  'zucchini',
  'garlic bread',
  'maple syrup',
  'basil',
  'coffee'
];
